export var ScriptOutputRuleSet;
(function (ScriptOutputRuleSet) {
    ScriptOutputRuleSet["None"] = "none";
    ScriptOutputRuleSet["EPrescription"] = "ePrescription";
    ScriptOutputRuleSet["PbsPrintedScript"] = "pbsPrintedScript";
})(ScriptOutputRuleSet || (ScriptOutputRuleSet = {}));
